/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { CircularProgress, Tooltip } from "@material-ui/core";
import { getRequest } from "utils/request";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Icon } from "@material-ui/core";

import { i18n } from '../../../translate/i18n';

import "../style.css";

import { postRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNotification } from "hooks/notification";
import format from "utils/dateFormat";

export default function Imports({ goBack }) {
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(0);
  const [openImport, setOpenImport] = useState(false);
  const [importList, setImportList] = useState([]);
  const [file, setFile] = useState("");
  const [updateUsers, setUpdateUsers] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);

  const { selectedCompany } = useNotification();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const useStyles = makeStyles((theme) => ({
    customWidth: {
      fontSize: 16
    },
  }));
  const classes = useStyles();

  const loadImports = async() => {
    setLoading(true);

    //VERIFICAR SE TEM ALGUM PROCESSO PENDENTE
    const ReturnGet = await getRequest(
      `customers/upload/isallowed?CompanyId=${selectedCompany.id}`
    );
    if (ReturnGet.success) {
      setIsAllowed(ReturnGet.data);
    }

    //BUSCA LISTA DE IMPORTS
    const ReturnGet2 = await getRequest(
      `/customers/upload?CompanyId=${selectedCompany.id}`
    );
    if (ReturnGet2.success) {
      setImportList(ReturnGet2.data);

      setLoading(false);

    }
  }

  useEffect(() => {
    loadImports();
  }, [update]);

  const handleOpenImport = () => {
    setOpenImport(true);
  };

  const handleCloseImport = () => {
    setOpenImport(false);
  };

  const handleFile = (file) => {
    setFile(file.target.files[0]);
  };

  const handleUploadFile = () => {
    if (file !== "") {
      handleCloseImport();

      const formData = new FormData();
      formData.append("CompanyId", selectedCompany.id);
      formData.append("update", updateUsers);
      formData.append("file", file);
      postRequest("/customers/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function () {
        setUpdate(update + 1);
      })
    }
  };

  const nameTemplate = (data) => {
    return (
      <span>{data.User.name}</span>
    )
  }

  const sendDateTemplate = (data) => {
    return (
      <span>{data.createdAt && format(data.createdAt,"dd/MM/yyyy HH:mm:ss")}</span>
    )
  }

  const visualizationDateTemplate = (data) => {
    return (
      <span>{data.updatedAt && format(data.updatedAt,"dd/MM/yyyy HH:mm:ss")}</span>
    )
  }
  
  const archiveTemplate = (data) => {
    return (
      <a
        href={data.file}
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <Icon
          className="far fa-file-excel"
          fontSize="small"
          style={{ color: "blue" }}
        />
      </a>
    )
  }

  const errorsTemplate = (data) => {
    return (
      <div>
        {data.errors && (
          <a
            href={data.errors}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            <Icon
              className="fas fa-exclamation-circle"
              fontSize="small"
              style={{ color: "red" }}
            />
          </a>
        )}
      </div>
    )
  }


  return (
    <div style={{overflowY: "auto",minHeight: 200}}>
      <div className="area-header-table-users">
        <h4>{i18n.t('clients_import')}</h4>

        {isAllowed ? (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <Tooltip 
              arrow
              classes={{tooltip: classes.customWidth}}
              title={ 
                i18n.t('reload')
              } 
            >
              <button
                className="refresh-button-import"
                disabled={loading}
                style={{marginRight: 10}}
                onClick={() => loadImports()}
              >
                {!loading ?
                  <>
                  <span className="refresh-icon-import">
                    <i class="fas fa-redo"></i>
                  </span>
                  </>
                :
                <CircularProgress size={30} />
                }
              </button>
            </Tooltip>
            <button
              type="button"
              className="btn btn-outline-success"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenImport()}
            >
              {i18n.t('importClients')}
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="tab-content">
        <div className="tab-pane show active" id="imports-datatable-preview">
          {!loading ? (
            <>
              <DataTable 
                dataKey="id"
                rowsPerPageOptions={[25,50,100]} 
                value={importList}
                paginator
                rows={25} 
                emptyMessage={i18n.t('noImportationsFinded')}
              >
                <Column body={nameTemplate} header={i18n.t('name')} ></Column>
                <Column field="statusDescription" header={i18n.t('status')}></Column>
                <Column body={sendDateTemplate} header={i18n.t('sendDate')} ></Column>
                <Column body={visualizationDateTemplate} header={i18n.t('attDate')} ></Column>
                <Column body={archiveTemplate} header={i18n.t('archive')} ></Column>
                <Column body={errorsTemplate} header={i18n.t('errors')} ></Column>
              </DataTable>
              <button
                type="button"
                className="btn btn-outline-danger mt-2 mr-2"
                style={{ height: 38 }}
                onClick={() => goBack()}
              >
                <i className="dripicons-gear"></i>{i18n.t('getBack')}
              </button>
            </>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
      <Dialog
        fullScreen={fullScreen}
        open={openImport}
        onClose={handleCloseImport}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Clientes - Processamento"}
        </DialogTitle>
        <DialogContent>
          <label>{i18n.t('archive')}</label>
          <input type="file" className="form-control-file" onChange={handleFile} />

          <div className="form-group col-md-6 mt-3">
            <input
              type="checkbox"
              checked={updateUsers}
              onChange={(value) => {
                setUpdateUsers(value.target.checked);
              }}
            />{" "}
            {i18n.t('allowAttUsers')} *
          </div>

          <p>
            *** {i18n.t('ifAllow')}
          </p>
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            className="btn btn-outline-success"
            style={{ marginRight: 10 }}
            onClick={() => handleUploadFile()}
          >
            {i18n.t('save')}
          </button>
          <button
            type="button"
            className="btn btn-outline-danger"
            style={{ marginRight: 10 }}
            onClick={() => handleCloseImport()}
          >
            {i18n.t('cancel')}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
